import { render, staticRenderFns } from "./novoOrcamento.vue?vue&type=template&id=50d510dc&"
import script from "./novoOrcamento.vue?vue&type=script&lang=js&"
export * from "./novoOrcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports